var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "MobileContainer",
    { attrs: { "flex-content": "" } },
    [
      _c(
        "MobileHeader",
        {
          attrs: { slot: "header", "nav-action": "menu", "show-cart": "" },
          slot: "header"
        },
        [_vm._v("\n    " + _vm._s(_vm.currentProduct.name) + "\n  ")]
      ),
      _vm._v(" "),
      _c("Configurator"),
      _vm._v(" "),
      _c(
        "MobileModal",
        {
          attrs: {
            animation: "modal",
            "center-content": "",
            "close-on-overlay": ""
          },
          model: {
            value: _vm.isShowHelpModal,
            callback: function($$v) {
              _vm.isShowHelpModal = $$v
            },
            expression: "isShowHelpModal"
          }
        },
        [_c("HelpModal", { class: _vm.$style.helpModal })],
        1
      ),
      _vm._v(" "),
      _c(
        "MobileModal",
        {
          attrs: { dialog: "", "center-content": "" },
          model: {
            value: _vm.showConfirmLeave,
            callback: function($$v) {
              _vm.showConfirmLeave = $$v
            },
            expression: "showConfirmLeave"
          }
        },
        [
          _c(
            "MobileConfirmDialog",
            {
              attrs: {
                title: "Abandon Boss Creation?",
                "cancel-text": "No",
                "confirm-text": "Yes, Abandon"
              },
              on: {
                confirm: function($event) {
                  return _vm.confirmLeave()
                },
                cancel: function($event) {
                  return _vm.cancelLeave()
                }
              }
            },
            [
              _vm._v(
                "\n      Are you sure you want to abandon this creation?\n    "
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/mobile/components/MobileConfigurator.vue?vue&type=template&id=78a9e1f7&
// module id = null
// module chunks = 